import { Form } from 'react-final-form';
import { useDispatch } from 'react-redux';

import SecurityPageWrapper from '../../../security/security-page-wrapper/SecurityPageWrapper';
import validate from '../../../utils/validate';
import { consumerConfirmationYupValidation } from './confirm-ad-images-form/validation';
import ConfirmAdImagesForm from './confirm-ad-images-form/ConfirmAdImagesForm';
import { confirmAdImagesPassword } from '../../../redux/demo-recreate/demoRecreateActions';

function ConfirmAdImages() {
  const dispatch = useDispatch();

  const consumerConfirmInitialValues = {
    password: '',
  };

  const handleConfirmAdImagesPassword = async (values) => {
    await dispatch(confirmAdImagesPassword(values));
  };

  return (
    <SecurityPageWrapper backgroundStyle='login'>
      <Form
        initialValues={consumerConfirmInitialValues}
        onSubmit={handleConfirmAdImagesPassword}
        subscription={{ submitting: true, pristine: true }}
        validate={(values) => validate(values, consumerConfirmationYupValidation())}
        render={({ handleSubmit }) => <ConfirmAdImagesForm onSubmit={handleSubmit} />}
      />
    </SecurityPageWrapper>
  );
}

export default ConfirmAdImages;
